import { render, staticRenderFns } from "./PlanDescription.vue?vue&type=template&id=27f7f662&"
import script from "./PlanDescription.vue?vue&type=script&lang=js&"
export * from "./PlanDescription.vue?vue&type=script&lang=js&"
import style0 from "./PlanDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports